var _path, _g, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMyProducts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M25 0H10C4.47715 0 0 4.47715 0 10V25C0 30.5228 4.47715 35 10 35H25C30.5228 35 35 30.5228 35 25V10C35 4.47715 30.5228 0 25 0Z",
    fill: "#87CBFE"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.16992 12.4404L17.9999 17.5504L26.7699 12.4704",
    stroke: "#87CBFE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 26.61V17.54",
    stroke: "#87CBFE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9296 7.48034L10.5896 10.4403C9.95182 10.8413 9.41927 11.3892 9.03653 12.0381C8.65379 12.687 8.43198 13.4181 8.38965 14.1703L8.38965 19.8203C8.43198 20.5725 8.65379 21.3037 9.03653 21.9526C9.41927 22.6015 9.95182 23.1494 10.5896 23.5503L15.9296 26.5203C16.5772 26.8314 17.2863 26.9929 18.0046 26.9929C18.723 26.9929 19.4321 26.8314 20.0796 26.5203L25.4196 23.5503C26.0575 23.1494 26.59 22.6015 26.9728 21.9526C27.3555 21.3037 27.5773 20.5725 27.6196 19.8203V14.1703C27.5773 13.4181 27.3555 12.687 26.9728 12.0381C26.59 11.3892 26.0575 10.8413 25.4196 10.4403L20.0796 7.47034C19.4321 7.15844 18.7223 6.99731 18.0035 6.99904C17.2847 7.00077 16.5757 7.16532 15.9296 7.48034Z",
    stroke: "#87CBFE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyProducts);
export default __webpack_public_path__ + "static/media/myProducts.1b69da3b6a03a3e8fe6e085bae8fcf68.svg";
export { ForwardRef as ReactComponent };